<google-pay-button
  *ngIf="!isLoading"
  [environment]="paymentEnvironment"
  [buttonColor]="buttonColor"
  [buttonType]="buttonType"
  [paymentRequest]="paymentRequest"
  [loadPaymentDataCallback]="paymentDataCallback"
  buttonSizeMode="fill"
  [style.width]="buttonWidth"
  [gpayDisabled]="!this.canTokenize"
></google-pay-button>
